import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPreviewClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      d="M4.75 4.75 19.25 19.25M19.25 4.75 4.75 19.25"
    />
  </svg>
);
export default SvgPreviewClose;
